import {useEffect, useState} from "react";
import axios from "axios";
import { config } from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import { history } from "../../../../Helpers/history";

export const useEditDeath = (actions, match) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const [patient_name, setPatientName] = useState('');
    const [patientNumbers, setPatientNumbers] = useState([]);
    const [showNumber, setShowNumber] = useState(false);
    const [openDialog, setDialog] = useState(false);
    const [patientDetails, setPatient] = useState({patient_name: '', dob: '', age: '', residence: '', gender: ''});
    const [state, setState] = useState({
        death_date: '', death_time: '', district: '', immediate: '', underlying: '', omorbid_illness: '', witnessed_by: '', recieved_by: '',  country: '', occupation: '',
        municipality: '', patient_type: 0, witness_tel: '', recievedby_tel: '', tribe: '', bed_no: 0, recievedby_rel: '',  witness_rel: '', religion: '', ward: '', ward_id: ''
    });
    const [nationality, setNationality] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [deathDetails, setDeathDetails] = useState({});
    const [wards, setWards] = useState([])
    const [ward, setWard] = useState('')
    const [visit_id, setVisitId] = useState('')
    const [updateDeath, setUpdateDeath] = useState(false)

    const reported_by = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;
    const {patient_death_id} = match.params;

    useEffect(() => {
        const formData = new FormData();
        formData.append('patient_death_id', patient_death_id)
        axios.post(`${config.smsUrl}/creport/deathupdateForm`, formData).then(res => {
            const data = res.data;
            const dt = data ? data : {};
            const dat = !dt.data ? [] : dt.data;
            const death = dat[0] ? dat[0] : {};
            const {patient_number} = death;
            handleClickPatientNumber(patient_number)
            setDeathDetails(death)
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
       setUpdateDeath(true)
    }, [])

    useEffect(() => {
        const {
            country, time_of_death, date_of_death, district_of_origin, bed_number, underying_cause_of_death,
            immediate_cause_of_death, witnessed_by_phone_no, witnessed_by_relationship, received_by_phone_no, received_by_relationship, received_by
        } = deathDetails;
        setState({
            ...deathDetails,
            death_date: date_of_death,
            death_time: time_of_death,
            district: district_of_origin,
            witness_rel: witnessed_by_relationship,
            underlying: underying_cause_of_death,
            immediate:immediate_cause_of_death,
            witness_tel: witnessed_by_phone_no,
            recieved_by: received_by,
            recievedby_tel: received_by_phone_no,
            recievedby_rel: received_by_relationship,
            bed_no: bed_number,

        });
        setNationality({value: country, label: country})

    }, [deathDetails])

    useEffect(() => {
        axios.get(`${config.smsUrl}/cbedmanager/getAllWards`).then(res => {
          const data = res.data
          const dt = data.wards ? data.wards : []
          setWards(dt)
        }).catch( err=> {
          logoutErrorMessage(err, null, actions)
        })
      
       
      }, [])

      const handleCloseDialog = () => {
        setDialog(false)
        history.push('reports/deathreports')
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
    }

    const handleChaneNationality = (value) => {
        setNationality(value)
    }

    const handleChangeWard = (value) => {
        setWard(value)
    }

    const retrievePreviousVisits = (p_number) => {
        const formData = new FormData();
        formData.append('patient_number', p_number);
        axios.post(`${config.smsUrl}/cpatient/get_patient_previous_visits`, formData).then((res) => {
            const data = res.data;
            const visit = !data ? {} : data;
            const visits = !visit.patient_visits ? [] : visit.patient_visits;
            const v = !visits[visits.length - 1] ? {}:visits[visits.length- 1] ;
            const id = v.visit_id ? v.visit_id : '';
            setVisitId(id);
        }).catch(err => {
            logoutErrorMessage(err, null, actions);
        })
    }

    const handleSearchPatientNumber = (event) => {
        setPatientName(event.target.value);
        const formData = new FormData();
        if (event.target.value !== '') {
            formData.append('name', event.target.value.toUpperCase());
            axios.post(`${config.smsUrl}/cvisit/search_patient_number`, formData)
                .then(res => {
                    const details = res.data;
                    const data = !details ? [] : details;
                    if (data[0] === "No Patient Found") {
                        setPatientNumbers([{value: '', label: 'No patient found'}])
                    } else {
                        const arr = data.map(item => ({
                            value: item.patient_number,
                            label: `(${item.patient_number}) ${item.first_name} ${item.last_name} - ${item.phone_no}`
                        }))
                        setPatientNumbers(arr)
                    }
                }).catch(error => {
                errorMessages(error, null, actions)
            });
            setShowNumber(true);
        } else {
            setShowNumber(false);
        }

    };

    const handleClickPatientNumber = (val) => {
        
        const formData = new FormData();
        formData.append('patient_number', val);
        axios.post(`${config.smsUrl}/cpatient/patient_update_form`, formData)
            .then(res => {
                const patient = res.data;
                const pt = !patient ? {} : patient;
                const {first_name, last_name, dob, Age, gender, address, patient_number} = pt
                setPatient({
                    patient_name: `${first_name ? first_name : ''} ${last_name ? last_name : ''}`,
                    age: Age ? Age : '', dob:dob ? dob : '', gender:gender ? gender : '',
                    residence: address ? address : '', patient_number: patient_number ?? ''
                })
                retrievePreviousVisits(patient_number) 
                setPatientName(`${first_name ? first_name : ''} ${last_name ? last_name : ''}`)
            }).catch(error => {
            errorMessages(error, null, actions)
        })
        setShowNumber(false)
    };

    const handleSubmit = (event) => {
        event.preventDefault()
        const {municipality, death_date, death_time, district, occupation, patient_type, tribe, underlying, immediate, witnessed_by, witness_rel, witness_tel, recieved_by, recievedby_rel, recievedby_tel, omorbid_illness, religion, bed_no} = state;
        const {patient_number} = patientDetails
       
        const payload = {patient_number: patient_number,
            date_of_death: death_date,
            time_of_death: death_time,
            district_of_origin: district,
            municipality: municipality,
            nationality: nationality.value,
            underying_cause_of_death: underlying,
            immediate_cause_of_death: immediate,

            tribe: tribe,
            patient_type: +patient_type,
            religion: religion,
            omorbid_illness: omorbid_illness,
            received_by: recieved_by,
            received_by_relationship: recievedby_rel,
            received_by_phone_no: recievedby_tel,
            witnessed_by: witnessed_by,
            witnessed_by_relationship: witness_rel,
            witnessed_by_phone_no: witness_tel,
            ward_id: ward.value,
            bed_number: bed_no,
            user_roles_id: user_roles_id,
            visit_id: visit_id,
            country: nationality.value,
            occupation: occupation,

        
        }
        setSubmitted(true)
        if (patient_type && death_date && death_time && immediate && underlying) {
            setIsSubmitted(true);
            axios.post(`${config.smsUrl}/creport/updateDeath`, payload).then(res => {
                const data = res.data;
                const val = !data ? [] : data;
                const value = val[1] ? val[1] : {};
                const _id = value.patient_death_id ? value.patient_death_id : ''
                setDialog(true);
                // setPatientId(_id)
                setIsSubmitted(false);
                actions.snackbarActions.snackSuccess('Death details updated successfully')
            }).catch(err => {
                setIsSubmitted(false);
                errorMessages(err, null, actions)
            })
        }
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    }
    return {
        patient_name, patientNumbers, showNumber, patientDetails, state, nationality, submitted, isSubmitted,
        deathDetails, reported_by, handleChange, handleChaneNationality, handleSearchPatientNumber, setState,
        handleClickPatientNumber, handleSubmit, closeSnackbar, userObj, token, _token, user_roles_id,
        setNationality, ward, wards, handleChangeWard, handleCloseDialog, openDialog, updateDeath
    }
}